import { render, staticRenderFns } from "./Restaurants.vue?vue&type=template&id=45f59aac&scoped=true"
import script from "./Restaurants.vue?vue&type=script&lang=ts"
export * from "./Restaurants.vue?vue&type=script&lang=ts"
import style0 from "./Restaurants.vue?vue&type=style&index=0&id=45f59aac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f59aac",
  null
  
)

export default component.exports